export const densityOptions = [
  {
    label: "宽松",
    value: "medium"
  },
  {
    label: "适中",
    value: "small"
  },
  {
    label: "紧凑",
    value: "mini"
  }
];

export const fontSizeOptions = [
  {
    label: "大字",
    value: "medium"
  },
  {
    label: "中等",
    value: "small"
  },
  {
    label: "细小",
    value: "mini"
  }
];
